/* eslint-disable @typescript-eslint/no-explicit-any */
import { APIStatusEnum } from '../../../common/reloadData/APIStatusEnum';
import fetchWithTimeout from './fetchWithTimeout';

type FetchWithRetry = {
  url: string;
  options: any;
  tm: number;
  AbortController: any;
  retry?: number;
};

export const delay = (t: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, t);
  });

const fetchWithRetry = async ({ url, options, tm, AbortController, retry }: FetchWithRetry): Promise<any> => {
  const response = await fetchWithTimeout(url, options, tm, AbortController).catch(async () => {
    if (retry && retry < 3) {
      await delay(1000);
      return fetchWithRetry({
        url,
        options,
        tm,
        AbortController,
        retry: retry + 1,
      });
    }
    return {
      status: APIStatusEnum.ERROR,
    };
  });
  return response;
};

export default fetchWithRetry;
